import { Box, Button, Card, CardContent, Grid, IconButton, Snackbar, Typography, useTheme } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { tokens } from '../../theme';
import Header from '../../components/Header';
import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';

const UserReportDetails = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { id } = useParams(); // passenger id
  const token = localStorage.getItem('token');

  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastmessage] = useState('');

  const [passenger, setPassenger] = useState(null);
  const [bookings, setBookings] = useState([]);

  const fetchPassenger = async () => {
    const res = await fetch(`${process.env.REACT_APP_APILINK}/passengers/${id}`, { headers: { token } });
    const data = await res.json();
    if (data?.success) setPassenger(data.passenger);
  };

  const fetchBookings = async () => {
    const res = await fetch(`${process.env.REACT_APP_APILINK}/passengers/${id}/bookings`, { headers: { token } });
    const data = await res.json();
    if (data?.success) setBookings(data.bookings || []);
  };

  useEffect(() => {
    fetchPassenger();
    fetchBookings();
    // eslint-disable-next-line
  }, [id]);

  const handleDeleteBooking = async (bookingId) => {
    const res = await fetch(`${process.env.REACT_APP_APILINK}/bookings/${bookingId}`, {
      headers: { token },
      method: 'DELETE',
    });
    const data = await res.json();
    setOpenToast(true);
    setToastmessage(data.message || 'Action completed');
    if (data.success) fetchBookings();
  };

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenToast(false);
  };

  const formatDob = (value) => {
    if (!value) return '-';
    try {
      const d = new Date(value);
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    } catch (e) {
      return value;
    }
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center" rowGap="10px" flexWrap="wrap-reverse">
        <Header title="REPORT BY USER" subtitle="Bookings by selected passenger" />
        <Box>
          <Link to={-1}>
            <Button
              sx={{
                backgroundColor: colors.blueAccent[700],
                color: colors.grey[100],
                fontSize: '14px',
                fontWeight: 'bold',
                padding: '10px 20px',
                '&:hover': { backgroundColor: colors.blueAccent[800] },
              }}
            >
              Back
            </Button>
          </Link>
        </Box>
      </Box>

      {/* Booking list */}
      <Card sx={{ backgroundColor: colors.primary[400] }}>
        <CardContent>
          <Typography variant="h5" color={colors.grey[100]} gutterBottom>
            Bookings
          </Typography>
          {bookings?.length === 0 ? (
            <Typography color={colors.grey[200]}>No bookings found.</Typography>
          ) : (
            <Box
              sx={{
                '& .MuiDataGrid-root': { border: 'none' },
                '& .MuiDataGrid-cell': { borderBottom: 'none' },
                '& .MuiDataGrid-columnHeaders': { backgroundColor: colors.blueAccent[700], borderBottom: 'none' },
                '& .MuiDataGrid-virtualScroller': { backgroundColor: colors.primary[400] },
                '& .MuiDataGrid-footerContainer': { borderTop: 'none', backgroundColor: colors.blueAccent[700] },
              }}
            >
              <DataGrid
                rows={bookings}
                getRowId={(row) => row.BookingID}
                columns={[
                  { field: 'CountryName', headerName: 'Destination', flex: 1, minWidth: 140 },
                  {
                    field: 'PackageName',
                    headerName: 'Package',
                    flex: 1,
                    minWidth: 120,
                    renderCell: (p) => <span>{p.row.PackageName || '-'}</span>,
                  },
                  {
                    field: 'GuideName',
                    headerName: 'Guide',
                    flex: 1,
                    minWidth: 160,
                    valueGetter: (params) =>
                      `${params.row.GuideName || ''} ${params.row.GuideSurname || ''}`.trim() || '-',
                  },
                  { field: 'BookingStartDate', headerName: 'Start Date', flex: 1, minWidth: 120 },
                  { field: 'BookingEndDate', headerName: 'End Date', flex: 1, minWidth: 120 },
                  {
                    field: 'View',
                    headerName: 'View',
                    sortable: false,
                    filterable: false,
                    renderCell: (cellValues) => (
                      <Link to={`/booking/${cellValues.row.BookingID}`}>
                        <IconButton
                          size="small"
                          title="View"
                          sx={{
                            backgroundColor: colors.blueAccent[600],
                            color: colors.grey[100],
                            borderRadius: 2,
                            '&:hover': { backgroundColor: colors.blueAccent[700] },
                          }}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </Link>
                    ),
                  },
                  // Delete action removed per request
                ]}
                autoHeight
                pageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
              />
            </Box>
          )}
        </CardContent>
      </Card>

      <Snackbar
        open={openToast}
        autoHideDuration={5000}
        onClose={handleCloseToast}
        message={toastMessage}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
    </Box>
  );
};

export default UserReportDetails;
